import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { hex2rgb } from '@mssgme/lib';
import styles from './styles.scss';

export const CardHeaderBackground = ({ background }) => {
    let backgroundImage;

    if (background.type === 'color') {
        backgroundImage = `linear-gradient(135deg, rgba(${hex2rgb(background.color)}, 1) 0%, rgba(${hex2rgb(
            background.color
        )}, .6) 100%)`;
    } else {
        backgroundImage = `url(${background.imageUrl})`;
    }

    return (
        <div
            className={classNames(styles.root, { [styles.cover]: background.type === 'image' })}
            style={{ backgroundImage }}
        />
    );
};

CardHeaderBackground.propTypes = {
    background: PropTypes.shape({
        type: PropTypes.oneOf(['color', 'image']).isRequired,
        color: PropTypes.string,
        image: PropTypes.string,
        imageUrl: PropTypes.string,
    }).isRequired,
};
